/**
 * Registers a new block provided a unique name and an object defining its behavior.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
import { registerBlockType } from '@wordpress/blocks';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * All files containing `style` keyword are bundled together. The code used
 * gets applied both to the front of your site and to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './style.scss';

/**
 * Internal dependencies
 */
import Edit from './edit';
import metadata from './block.json';
import {__} from "@wordpress/i18n";

/**
 * Every block starts by registering a new block type definition.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-registration/
 */
registerBlockType( metadata.name, {
	title: metadata.title,
	/**
	 * @see ./edit.js
	 */
	icon: {
		src: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_34_317)">
				<rect width="24" height="24" fill="#D9D9D9"/>
				<rect width="24" height="24" fill="url(#paint0_linear_34_317)"/>
				<g filter="url(#filter0_d_34_317)">
					<g filter="url(#filter1_d_34_317)">
						<rect x="2" y="9" width="20" height="7" rx="2" fill="white"/>
					</g>
					<rect x="10" y="12" width="5" height="1" rx="0.5" fill="#8A8A8A"/>
					<rect x="13" y="10" width="5" height="1" rx="0.5" transform="rotate(90 13 10)" fill="#8A8A8A"/>
				</g>
			</g>
			<defs>
				<filter id="filter0_d_34_317" x="-18" y="9" width="60" height="47" filterUnits="userSpaceOnUse"
						color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								   result="hardAlpha"/>
					<feOffset dy="20"/>
					<feGaussianBlur stdDeviation="10"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34_317"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34_317" result="shape"/>
				</filter>
				<filter id="filter1_d_34_317" x="-2" y="9" width="28" height="15" filterUnits="userSpaceOnUse"
						color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								   result="hardAlpha"/>
					<feOffset dy="4"/>
					<feGaussianBlur stdDeviation="2"/>
					<feComposite in2="hardAlpha" operator="out"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_34_317"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_34_317" result="shape"/>
				</filter>
				<linearGradient id="paint0_linear_34_317" x1="1.752" y1="24.168" x2="19.368" y2="-4.8"
								gradientUnits="userSpaceOnUse">
					<stop stop-color="#3D12F9"/>
					<stop offset="1" stop-color="#FD2B4C"/>
				</linearGradient>
				<clipPath id="clip0_34_317">
					<rect width="24" height="24" fill="white"/>
				</clipPath>
			</defs>
		</svg>
	},
	attributes: {
		postId: {
			type: 'number',
			default: 0
		},
	},
	edit: Edit,
});
